const baseApiEndpoint = process.env.REACT_APP_REST_ENDPOINT;

const getBaseRoute = (type) => {
  switch (type) {
    default:
      return baseApiEndpoint;
  }
};

export const baseUrl = (type) => {
  if (getBaseRoute(type)) return getBaseRoute(type);

  throw new Error("Can not access to env for return public URL");
};
